/** Общие параметры приложения (аналог APP из Config.gs). */
export const APP = {
    NAME: 'Учёт запчастей',
    VERSION: '0.0.1',
    CURRENCY: 'CNY',
    TIME_ZONE: 'Europe/Moscow',
    LOCALE: 'ru-RU'
};
//# sourceMappingURL=app.js.map